export default [
    {
        path: '/user',
        component: () => import('@/views/user')
    },
    {
        path: '/user/add',
        component: () => import('@/views/user/add')
    },
    {
        path: '/user/:id',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/user/detail')
    },
    {
        path: '/user/:id/edit',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/user/edit')
    },
]